<template>
  <div class="model-info-box">
    <header>
      <img class="head-img" :src="modelInfo.head">
      <span>{{ modelInfo.name }}</span>
      <img class="focus-img" :src="IMG_URL + 'logos/ug-attention.png'" />
    </header>
    <ul class="info">
      <li class="info-item">
        <label class="key">身高：</label>
        <span class="value">{{ modelInfo.height }}</span>
      </li>
      <li class="info-item">
        <label class="key">三围：</label>
        <span class="value">{{ modelInfo.measurements }}</span>
      </li>
      <li class="info-item">
        <label class="key">来自：</label>
        <span class="value">{{ modelInfo.origin }}</span>
      </li>
      <li class="info-item">
        <label class="key">职业：</label>
        <span class="value">{{ modelInfo.profession }}</span>
      </li>
      <li class="info-item">
        <label class="key">昵称：</label>
        <span class="value">{{ modelInfo.nick }}</span>
      </li>
      <li class="info-item">
        <label class="key">标签：</label>
        <span class="value">{{ modelInfo.labels }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    props: {
      info: {
        type: Object,
        required: true
      },
      labels: {
        type: Array,
         default: [],
        // required: true
      }
    },
    computed: {
      modelInfo () {
        const measurements = `${ this.info.bust || '暂无' }/${ this.info.waist || '暂无' }/${ this.info.hip || '暂无' }`;
        let labels = [];
        if (this.labels) {
          this.labels.forEach(item => {
            labels.push(item.chinese);
          });
        }

        return {
          head: this.info.headPortrait,
          name: this.info.webName || '暂无',
          height: this.info.height || '暂无',
          measurements,
          origin: this.info.liveInCity.city || '暂无',
          profession: this.info.profession && this.info.profession.length ? this.info.profession.join(', ') : '暂无',
          nick: this.info.nickName || '暂无',
          labels: labels.length ? labels.join(', ') : '暂无'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .model-info-box {
    width: 240px;
    padding: 20px;
    box-shadow: 0 0 5px #D6D6D6;
    background-color: white;
    font-size: 14px;
    header {
      position: relative;
      display: flex;
      align-items: center;
      span {
        font-size: 16px;
        font-weight: bold;
        margin-left: 20px;
      }
    }
    .head-img {
      width: 66px;
      border-radius: 33px;
    }
    .focus-img {
      position: absolute;
      top: 11.5px;
      right: -30px;
      width: 83px;
    }
    .info {
      padding: 20px 0;
      .info-item {
        padding: 3px;
        display: flex;
        .key {
          width: 45px;
          color: #9D9D9D;
          margin-right: 5px;
        }
        .value {
          flex: 1;
          color: black;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ModelInfo.vue